import { ProductionCellDTO } from './ProductionCellDTO';
import { DataSummaryDTO } from './DataSummaryDTO';
import { LaboratoryDTO } from './LaboratoryDTO';

export class CellLaboratoryDashboardDTO {	

	laboratory: LaboratoryDTO;
	summary: DataSummaryDTO;	
	productionCells: ProductionCellDTO[];	
}